import http from "../httpService";

const apiEndpoint = "/report/team";

export function getReportTeamSummary(input) {
  const query = (input) ? Object.keys(input).map(key=> { return `${key}=${input[key]}`}).join('&') : ''
  
  return http.get(apiEndpoint + '/summary' + ((query) ? '/?' + query : ''))
}


export function getReportPerTeam(id, input) {
  const query = (input) ? Object.keys(input).map(key=> { return `${key}=${input[key]}`}).join('&') : ''

  return http.get(apiEndpoint + '/' + id + ((query) ? '/?' + query : ''))
}


